import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "item" }
const _hoisted_2 = { class: "list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Bar = _resolveComponent("Bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { repo: _ctx.repo }, null, 8, ["repo"]),
    _createVNode(_component_Bar, {
      langs: _ctx.langs,
      "repo-full-name": _ctx.repo.full_name
    }, null, 8, ["langs", "repo-full-name"]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.langs[_ctx.repo.full_name]
          ? Object.entries(_ctx.langs[_ctx.repo.full_name])
              .filter(
                ([, v]) =>
                  v /
                    Object.values(_ctx.langs[_ctx.repo.full_name]).reduce(
                      (a, b) => a + b,

                      0
                    ) >
                  0.005
              )
              .map(([lang, val]) => `${lang}: ${val}`)
              .join(', ')
          : 'No data'), 1)
  ]))
}